import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import SkeletonLoder from '../../common/skeletonLoder';
import { fetchApi } from '../../../utils/methods';
import {  GetCompanyAdminRewardPeriods } from '../../../redux/constants/apiConstants';
// import { RewarDocumentsContainer } from './styles';
import { AdminDownloadIcon, BackArrowFeed, NewFilterIcon, /*VerticalDotsIcon*/ } from '../../../utils/icons';
// import { ImageUrl } from '../../../utils/constants';
import { HeaderRow } from '../../EventDetails/styles';
// import { DownAngleV2 } from '../../SocialFeedsV2/styles';
// import { Dropdown, DropdownButton } from 'react-bootstrap';
import SpotRewardsListView from './SpotRewardsListView';
import { BrandingTab, BrandingTabContainer, ContainerMain } from '../../common/commonStyles'
import { connect } from 'react-redux';
import {withRouter } from 'react-router-dom';
import HoverButton from '../../common/HoverButton';
import dayjs from 'dayjs';
import { RewarDocumentsContainer } from '../Documents/styles';
import SearchInput from '../Documents/SearchInput';
import AllOptionsFilterPopup from '../../common/CommonDeptLoc/AllOptionsFilterPopup';
import { getCompanyDepartment, getCompanyLocation } from '../../../redux/actions';
import {GetSpotPointsLeaders} from '../../../redux/constants/apiConstants';
import SpotPointsReportModal from '../Rewards/SpotPointsReportModal';
import CommonDropdown from '../../common/CommonDropDown/CommonDropdown';
import { AdminIconContainer } from '../../RecogntionAdmin/styles';
import { useHistory } from "react-router-dom";
import Waiting from '../../Waiting';

const tabs = [
  { label: 'Spot Awards', path: 'dashboard' },
  //   { label: 'Documents', path: 'documents' },
  // future-proof
  // { label: 'Settings', path: 'settings', component: Settings },
];

const userType = [
  { name: "Employee", id: 1 },
  { name: "Spouse", id: 2 },
  { name: "Dependent", id: 3 },
];

const SpotPointsRewardsDashboard = ({companyInfo,brandingColor,/*yearList,*/locationDetails,departmentDetails,getCompanyLocation,getCompanyDepartment}) => {

  const [loading, setLoading] = useState(false);
  //   const [showUploadModal, seSshowUploadModal] = useState(false);
  //   const[selectedDoc, setSelectedDoc]=useState(null);
  const [search, setSearch] = useState("");
  // const [sort, setSort] = useState("");
  const[monthDropdownOpen,setMonthDropdownOpen] = useState(false);
  const [spotPoints , setSpotPointsModal] = useState(false);
  const [selectedYear, setSelectedYear] = useState(dayjs().format("YYYY"));
  const [rewardPeriodData, setRewardPeriodData] = useState([]);
  const [isDropdownOpen,setIsDropdownOpen] = useState(false);
  const [spotPointsLeaders, setSpotPointsLeaders] = useState([]);
  // const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const pageRef = React.useRef(1);
  const [showYearDropdown, setShowYearDropdown] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState({
    users: [],
    departments: [],
    locations: []
  });
  const history = useHistory();
  const latestSearchRef = React.useRef("");


  useEffect(()=>{
    getCompanyLocation(companyInfo?.id);
    getCompanyDepartment(companyInfo?.id);
    fetchCompanyRewardsDetailsYearwise()
  },[])
  
  useEffect(() => {
    if (!selectedYear?.reward_period_id) return;
    pageRef.current = 1;
    setSpotPointsLeaders([]);
    setHasMore(true);
    setLoadingMore(false);
    FetchSpotPointsLeaders(); // page 1
  }, [selectedYear?.reward_period_id, selectedFilters.departments, selectedFilters.locations]);




  // useEffect(() => {
  //   const delay = window.setTimeout(() => {
  //     handleSearch(search);
  //   }, 400);
  
  //   return () => window.clearTimeout(delay);
  // }, [search]);


  useEffect(() => {
    const delay = window.setTimeout(() => {
      if (search !== undefined) {
        latestSearchRef.current = search; // ✅ SET 
        pageRef.current = 1;
        setSpotPointsLeaders([]);
        setHasMore(true);
  
        FetchSpotPointsLeaders(search, true);
      }
    }, 1000); // ⏱️ wait 500ms after user stops typing
  
    return () => window.clearTimeout(delay);
  }, [search]);


  


  const fetchCompanyRewardsDetailsYearwise = async() =>{
    setLoading(true);
    try {

      const companyRewardsData = await fetchApi(GetCompanyAdminRewardPeriods+'?company_id='+ companyInfo.id , "GET");
      if(companyRewardsData.status === 'success'){

        const allPeriods = companyRewardsData?.data?.periods || [];
        // ✅ Filter years >= 2026
        const filteredPeriods = allPeriods.filter((item) => {
          const year = dayjs(item.reward_start_date).year();
          return year >= 2026;
        });
  
        setRewardPeriodData(filteredPeriods);
        setSelectedYear(filteredPeriods?.[0] || null);
        setShowYearDropdown(filteredPeriods.length > 1);

      }else{
        toast.error(companyRewardsData.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }
  

  const selectYearData = (value) => {
    setSelectedYear({ ...value }); // ✅ force new reference
  };

  




  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
  
      if (
        scrollTop + windowHeight >= fullHeight - 100 &&
        hasMore &&
        !loadingMore
      ) {
        FetchSpotPointsLeaders();
      }
    };
  
    window.addEventListener("scroll", handleScroll);
  
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, loadingMore]);

  


  const FetchSpotPointsLeaders = async (searchValue = search, isSearch = false) => {
    const rewardPeriodId = selectedYear?.reward_period_id;
   
    if (!rewardPeriodId) return; // ✅ STOP API CALL
   
    // if (loadingMore || (!hasMore && !isSearch)) return;
    if (loadingMore) return;
    if (!hasMore && !isSearch && pageRef.current !== 1) return;
  
    setLoadingMore(true);
    const currentPage = pageRef.current;
  
    const payload = {
      company_id: companyInfo?.id,
      reward_period_id: rewardPeriodId,
      page: currentPage,
      limit: 25,
      search: searchValue,
      department_ids: selectedFilters.departments.length
        ? selectedFilters.departments
        : [],
  
      location_ids: selectedFilters.locations.length
        ? selectedFilters.locations
        : [],
      // department_ids: selectedFilters.departments,
      // location_ids: selectedFilters.locations,
    };
  
    try {
      const res = await fetchApi(GetSpotPointsLeaders, "POST", payload);

      if (latestSearchRef.current !== searchValue) {
        return;
      }
      if (res.status === "success") {
        const newData = res?.data?.users || [];

        setSpotPointsLeaders((prev) =>
          pageRef.current === 1 ? newData : [...prev, ...newData]
        );
  
        // setSpotPointsLeaders((prev) => [...prev, ...newData]);
  
        const currentPage = res?.data?.pagination?.current_page;
        const lastPage = res?.data?.pagination?.last_page;
  
        setHasMore(currentPage < lastPage);
  
        // ✅ increment page ONLY after success
        pageRef.current += 1;
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    } finally {
      setLoadingMore(false);
    }
  };


  const updateDropdown = (title, id, /*titleKey, idKey*/) => {
    window.console.log("titiel",title);
    window.console.log("id",id)

    window.console.log("updateDropdown",id)
    // this.setState(
    //   {
    //     [titleKey]: title,
    //     [idKey]: id,
    //   },
    //   () => {
    //     this.viewUsersToAdd();
    //   }
    // );
  };

  // const handleSearch = (value) => {
  //   setSearch(value);
  //   pageRef.current = 1;
  //   setSpotPointsLeaders([]);
  //   setHasMore(true);
  //   FetchSpotPointsLeaders(value, true);
  // };

  


  return (
    <>
      <ContainerMain padding={"25px 0px 0px 0px"}>
        <div className='content-wrap'>
          <BrandingTabContainer isCompare={"0px"}>
            <div className='wrapper backbutton'>
              <AdminIconContainer onClick={()=> history.goBack()}>{BackArrowFeed("#DA6C74")}</AdminIconContainer>
              {tabs.map((tab) => (
                <BrandingTab
                  key={tab.id}
                  active={true}
                  background={brandingColor ? brandingColor : "#0b4170"}
                  id={"step"+tab.id}
                >
                  {tab.label}
                </BrandingTab>
              ))}
            </div>
            

            {showYearDropdown ? <div style={{display:'flex'}}>
              <CommonDropdown
                tileContainerStyle={{ width: "100%", padding:"0px", margin: "0px" }}
                dropdownButtonPadding={"0px 35px 0px 12px"}
                dropdownStyle={{ top: "95px" }}
                // labelText={""}
                isRequired={true}
                dropdownOpen={monthDropdownOpen}
                placeholder={"Year"}
                title={
                  dayjs(selectedYear?.reward_start_date).format("MMM YYYY") + " - " + dayjs(selectedYear?.reward_end_date).format("MMM YYYY")
                }
                id="dropdown-recurring"
                onClick={() => setMonthDropdownOpen(!monthDropdownOpen)}
                data={rewardPeriodData}
                active={selectedYear}
                onSelectParameter={["year", "firstDate", "month"]}
                // valueString={"Points"}
                itemValue={true}
                valueIndex={0}
                labelMargin={"0px"}
                onSelect={selectYearData}
                dropIcon={true}
                isManagerMargin={'0px'}
                top={'8px'}
                showDateRange={true}
                dateRangeKeys={{
                  start: "reward_start_date",
                  end: "reward_end_date"
                }}
              />
            </div>:null}
          </BrandingTabContainer>

          <RewarDocumentsContainer>
            <SearchInput placeholder='Search'   
              // onChange={(value) => {
              //   handleSearch(value);
              // }} 
              onChange={(value) => setSearch(value)}
            />
            <div className='icons-container'>
              <span onClick={()=> setSpotPointsModal(true)} className='icons' >{AdminDownloadIcon()}</span>
              <div
                className="compare"
                id="filterSection"
                style={{ position: "relative" }}
              >
                <HoverButton
                  title={"Filter"}
                  svgPath={<NewFilterIcon />}
                  activeColor={"#DA6C74"}
                  inActiveColor={"#DA6C74"}
                  backgroundColor={"#FCF2F3"}
                  backgroundColorActive={"#DA6C74"}
                  onClick={() =>
                    setIsDropdownOpen(!isDropdownOpen)
                  }
                  width={"22px"}
                  height={"22px"}
                  fillOpacity={1}
                />
                <AllOptionsFilterPopup
                  companyId={companyInfo?.id}
                  setSelectedFilters={setSelectedFilters}
                  setIsDropdownOpen={()=>setIsDropdownOpen(!isDropdownOpen)}
                  isDropdownOpen={isDropdownOpen}
                  // activeSubTab={this.state.activeSubTab}
                  updateDropdown={updateDropdown}
                  userType={userType}
                  // WellnessInterests={WellnessInterests}
                  // updateWellnessDropdown={this.updateWellnessDropdown}
                  filters={["department", "location"]}
                  // selectType={"single"}
                  page={"active"}
                  locationDetails={locationDetails}
                  departmentDetails={departmentDetails}
                />
              </div>
    
            </div>

          </RewarDocumentsContainer> 
          {loading ?
            <HeaderRow>
              {Array.from({ length: 3 }).map((_, index) => (
                <SkeletonLoder
                  key={index}
                  width="1248px"
                  height="387px"
                  style={{ gap: "25px" }}
                />
              ))}
            </HeaderRow> : 
             
            <div>
              { loadingMore ? <Waiting/> : <SpotRewardsListView
                // rewards={documentsData}
                leaders={spotPointsLeaders}
                loadingMore={loadingMore}
              />}
            </div>}
        </div>

        {spotPoints && <SpotPointsReportModal selectedYear={selectedYear} companyInfo={companyInfo} departmentDetails={departmentDetails}  locationDetails={locationDetails} show={spotPoints} title={'Export Rewards Report'} onCancel={()=>setSpotPointsModal(false)}/>}
        

      </ContainerMain>

    </>
  )
}

SpotPointsRewardsDashboard.propTypes = {
  companyInfo: PropTypes.object,
  brandingColor: PropTypes.string,
  yearList:PropTypes.array,
  history:PropTypes.object,
  match:PropTypes.object,
  locationDetails:PropTypes.array,
  departmentDetails:PropTypes.array,
  getCompanyDepartment:PropTypes.func,
  getCompanyLocation:PropTypes.func
}
  
const mapStateToProps = (state) => ({
  brandingColor:state.wellnessDashboard.brandingColor,
  locationDetails: state.register.locationDetails,
  departmentDetails: state.register.departmentDetails
});

const mapDispatchToProps = (dispatch) => ({
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
  getCompanyDepartment: (id) => dispatch(getCompanyDepartment(id))
});

  
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SpotPointsRewardsDashboard));
